import Header from './components/Header';
import Hero from './components/Hero';
import EventDays from './components/EventDays';
import Speaker from './components/Speaker';
import Agenda from './components/Agenda';
import Tickets from './components/Tickets';
import Venues from './components/Venues';
import FAQ from './components/FAQ';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <EventDays />
        <Speaker />
        <Agenda />
        <Tickets />
        <Venues />
        <FAQ />
        <section className="closing-section">
          <div className="container closing-inner">
            <span className="eyebrow">EL SIGUIENTE PASO ES TUYO</span>
            <h2>El cupo es limitado.<br />Los lugares se asignan<br />por orden de compra.<br /><em>Aparta tu lugar hoy.</em></h2>
            <a className="button button-gold" href="#boletos">COMPRAR MI BOLETO ↗</a>
            <span className="closing-decoration" aria-hidden="true">M.</span>
          </div>
        </section>
      </main>
      <footer className="footer"><div className="container footer-inner"><span className="footer-brand">M<span>.</span> <small>ESCUELA DE LIDERAZGO</small></span><span>14 DE NOVIEMBRE DE 2026 · CUAUTITLÁN IZCALLI</span><a href="#inicio">VOLVER ARRIBA ↑</a></div></footer>
    </>
  );
}

export default App;